const TEXT = {
  ar: {
    screenTitle: "أرشيف مبيعات الجملة",
    screenSubheader: "إدارة بيانات مبيعات الجملة المفقودة المحفوظة محليًا",
    archiveTab: "الأرشيف",
    totalsTab: "رفع إجماليات الفواتير",
    addRow: "إضافة سطر",
    importExcel: "استيراد من إكسل",
    detailsTitle: "تفاصيل سطر الأرشيف",
    noRows: "لا توجد بيانات محفوظة في الأرشيف حتى الآن",
    importDialogTitle: "استيراد أرشيف مبيعات الجملة من إكسل",
    createDialogTitle: "إضافة سطر مبيعات للأرشيف",
    importErrorsTitle: "نتائج الاستيراد",
    importSuccess: "تم استيراد البيانات بنجاح",
    importPartial: "تم استيراد بعض الصفوف مع وجود أخطاء",
    importFailed: "فشل استيراد الملف",
    rowsImported: "عدد الصفوف المستوردة",
    rowsFailed: "عدد الصفوف التي فشلت",
    rowNumber: "رقم الصف",
    accessPermission: "تمكين الدخول إلى شاشة أرشيف مبيعات الجملة",
    addPermission: "تمكين إضافة واستيراد بيانات أرشيف مبيعات الجملة",
    uploadTotals: "رفع الإجماليات",
    calculateRatios: "حساب نسب الأصناف",
    convertToArchive: "تحويل إلى الأرشيف",
    downloadTemplate: "تحميل نموذج الإكسل",
    replaceExampleRow: "استبدل صف المثال في النموذج قبل الرفع.",
    deleteInvoiceTotals: "حذف إجماليات الفواتير",
    year: "السنة",
    month: "الشهر",
    invoiceTotalRows: "عدد الصفوف",
    invoiceNewRows: "جديدة",
    invoiceConvertedRows: "محوّلة",
    convertedLinesRemain:
      "سطور الأرشيف المحوّلة تبقى في الأرشيف حتى تُحذف من تبويب الأرشيف.",
    invoiceTotalsDeleted: "تم حذف إجماليات الفواتير",
    deleteCustomerRatios: "حذف نسب العملاء",
    selectAll: "تحديد الكل",
    clearSelection: "إلغاء التحديد",
    searchCustomers: "بحث عن عميل",
    productCount: "عدد الأصناف",
    ratioSource: "المصدر",
    referenceMonth: "شهر المرجع",
    ratioSourceOdoo: "أودو",
    ratioSourceManual: "يدوي",
    confirmDeleteRatios:
      "سيتم حذف نسب العملاء المحددين. سطور الأرشيف المحوّلة لن تتغير.",
    selectedCustomers: "عدد العملاء",
    selectedRatioRows: "عدد صفوف النسب",
    ratiosDeleted: "تم حذف نسب العملاء",
    deleteArchiveLines: "حذف من الأرشيف",
    archiveDeleteHelp: "اختر سنة وشهرًا أو مصدر البيانات أو الاثنين معًا.",
    notSelected: "بدون تحديد",
    noSourceFilter: "بدون تصفية المصدر",
    confirmDeleteArchive: "سيتم حذف سطور الأرشيف المطابقة.",
    archiveRowCount: "عدد السطور",
    archivePriceTotal: "مجموع القيمة مع الضريبة",
    invoicesReturnToNew:
      "فواتير التخصيص المطابقة ستعود حالتها إلى جديدة ويمكن تحويلها مرة أخرى.",
    archiveLinesDeleted: "تم حذف سطور الأرشيف",
    nothingToDelete: "لا توجد سطور مطابقة للحذف",
    totalsHelp:
      "استخدم الأزرار بالترتيب: رفع الإجماليات، ثم حساب النسب، ثم التحويل إلى الأرشيف.",
    skipExistingCheck: "تخطي فحص البيانات السابقة",
    uploadDialogTitle: "رفع إجماليات الفواتير",
    confirmExistingTitle: "توجد بيانات سابقة",
    confirmExistingHelp:
      "بعض التواريخ موجودة مسبقًا أو تتطابق مع صفوف محفوظة. المتابعة تكمل ترقيم اليوم من آخر رقم.",
    continueUpload: "متابعة الرفع",
    copyErrors: "نسخ الأخطاء",
    copied: "تم النسخ",
    nothingSaved: "لم يتم حفظ أي صف",
    uploadSaved: "تم حفظ الفواتير",
    ratiosTitle: "نسب الأصناف حسب العميل",
    manualRequired: "تحتاج إدخال يدوي",
    editRatios: "تعديل النسب",
    addProduct: "إضافة صنف",
    percent: "النسبة %",
    ratioTotal: "المجموع",
    saveRatios: "حفظ النسب",
    ratiosMustTotal: "يجب أن يكون مجموع النسب 100%",
    calculateDone: "اكتمل حساب النسب",
    convertDone: "اكتمل التحويل",
    convertSkipped: "فواتير لم تُحوَّل",
    noRatios: "لا توجد نسب لهذا العميل",
    out_invoice: "فاتورة",
    out_refund: "مرتجع",
    fields: {
      invoice_id: "رقم الفاتورة",
      invoice_name: "مرجع الفاتورة",
      invoice_date: "تاريخ الفاتورة",
      product_id: "الصنف",
      partner_id: "العميل",
      invoice_user_id: "المندوب",
      move_type: "نوع الحركة",
      state: "الحالة",
      qty: "الكمية",
      price_subtotal: "القيمة بدون ضريبة",
      price_total: "القيمة مع الضريبة",
      source_label: "مصدر البيانات",
      notes: "ملاحظات",
      product_name: "اسم الصنف",
      partner_name: "اسم العميل",
      invoice_user_name: "اسم المندوب",
      customer_name: "اسم العميل",
      salesman_name: "اسم المندوب",
      amount_total: "الإجمالي شامل الضريبة",
      created_at: "تاريخ الإنشاء",
      updated_at: "آخر تحديث",
      created_by: "أضيف بواسطة",
      updated_by: "آخر تعديل بواسطة",
      code: "كود الصنف",
    },
  },
  en: {
    screenTitle: "Wholesale Sales Archive",
    screenSubheader: "Manage locally stored missing wholesale sales rows",
    archiveTab: "Archive",
    totalsTab: "Upload invoice totals",
    addRow: "Add Row",
    importExcel: "Import Excel",
    detailsTitle: "Archive Row Details",
    noRows: "No archived sales rows found yet",
    importDialogTitle: "Import Wholesale Sales Archive from Excel",
    createDialogTitle: "Add Wholesale Sales Archive Row",
    importErrorsTitle: "Import Result",
    importSuccess: "Import completed successfully",
    importPartial: "Some rows were imported and some rows failed",
    importFailed: "Import failed",
    rowsImported: "Imported rows",
    rowsFailed: "Failed rows",
    rowNumber: "Row number",
    accessPermission: "Enable access to wholesale sales archive screen",
    addPermission: "Enable adding and importing wholesale sales archive data",
    uploadTotals: "Upload totals",
    calculateRatios: "Calculate item ratios",
    convertToArchive: "Convert to archive",
    downloadTemplate: "Download Excel template",
    replaceExampleRow: "Replace the example row in the template before uploading.",
    deleteInvoiceTotals: "Delete invoice totals",
    year: "Year",
    month: "Month",
    invoiceTotalRows: "Rows",
    invoiceNewRows: "New",
    invoiceConvertedRows: "Converted",
    convertedLinesRemain:
      "Converted archive lines stay in the archive until they are deleted from the archive tab.",
    invoiceTotalsDeleted: "Invoice totals deleted",
    deleteCustomerRatios: "Delete customer ratios",
    selectAll: "Select all",
    clearSelection: "Clear selection",
    searchCustomers: "Search customers",
    productCount: "Products",
    ratioSource: "Source",
    referenceMonth: "Reference month",
    ratioSourceOdoo: "Odoo",
    ratioSourceManual: "Manual",
    confirmDeleteRatios:
      "Ratios for the selected customers will be deleted. Converted archive lines are left unchanged.",
    selectedCustomers: "Customers",
    selectedRatioRows: "Ratio rows",
    ratiosDeleted: "Customer ratios deleted",
    deleteArchiveLines: "Delete from archive",
    archiveDeleteHelp: "Choose a year and month, a data source, or both.",
    notSelected: "Not selected",
    noSourceFilter: "No source filter",
    confirmDeleteArchive: "The matching archive lines will be deleted.",
    archiveRowCount: "Rows",
    archivePriceTotal: "Total incl. tax",
    invoicesReturnToNew:
      "Matching allocated invoices return to new and can be converted again.",
    archiveLinesDeleted: "Archive lines deleted",
    nothingToDelete: "No matching rows to delete",
    totalsHelp:
      "Use the buttons in order: upload totals, calculate ratios, then convert to the archive.",
    skipExistingCheck: "Skip the existing-data check",
    uploadDialogTitle: "Upload invoice totals",
    confirmExistingTitle: "Existing data found",
    confirmExistingHelp:
      "Some dates already have invoices, or a row matches saved data. Continuing keeps numbering from the last number of that day.",
    continueUpload: "Continue upload",
    copyErrors: "Copy errors",
    copied: "Copied",
    nothingSaved: "Nothing was saved",
    uploadSaved: "Invoices saved",
    ratiosTitle: "Item ratios by customer",
    manualRequired: "Manual entry required",
    editRatios: "Edit ratios",
    addProduct: "Add product",
    percent: "Percent",
    ratioTotal: "Total",
    saveRatios: "Save ratios",
    ratiosMustTotal: "Ratios must total 100%",
    calculateDone: "Ratio calculation finished",
    convertDone: "Conversion finished",
    convertSkipped: "Invoices not converted",
    noRatios: "This customer has no ratios",
    out_invoice: "Invoice",
    out_refund: "Refund",
    fields: {
      invoice_id: "Invoice ID",
      invoice_name: "Invoice Reference",
      invoice_date: "Invoice Date",
      product_id: "Product",
      partner_id: "Customer",
      invoice_user_id: "Salesman",
      move_type: "Move Type",
      state: "State",
      qty: "Qty",
      price_subtotal: "Subtotal",
      price_total: "Total Incl. Tax",
      source_label: "Source Label",
      notes: "Notes",
      product_name: "Product Name",
      partner_name: "Customer Name",
      invoice_user_name: "Salesman Name",
      customer_name: "Customer Name",
      salesman_name: "Salesman Name",
      amount_total: "Total Incl. VAT",
      created_at: "Created At",
      updated_at: "Updated At",
      created_by: "Created By",
      updated_by: "Updated By",
      code: "Product Code",
    },
  },
};

const getLanguageBucket = (language) => (language === "ar" ? TEXT.ar : TEXT.en);

export const getWholesaleSalesArchiveText = (language) =>
  getLanguageBucket(language);

export const getWholesaleSalesArchiveFieldLabel = (field, language) =>
  getLanguageBucket(language).fields[field] || field;

export const getWholesaleSalesArchivePermissionLabel = (field, language) => {
  const bucket = getLanguageBucket(language);
  if (field === "can_access_wholesale_sales_archive") {
    return bucket.accessPermission;
  }
  if (field === "can_add_wholesale_sales_archive") {
    return bucket.addPermission;
  }
  return field;
};
